import Img from '@/components/Img';
import styles from './Foundation.module.scss';
import Text from '@/components/Text/Text';

type FoundationSectionProps = {
  data: {
    title: string;
    description: string;
    cards: {
      title: string;
      icon: {
        url: string;
      };
      subtitle: string;
    }[];
  };
};

const FoundationSection = ({ data }: FoundationSectionProps) => (
  <section className={styles.foundationSection}>
    <div className={styles.content}>
      <div className={styles.textContainer}>
        <Text tag='h2'>{data.title}</Text>
        <Text
          className={styles.description}
          tag='p'
        >
          {data.description}
        </Text>
      </div>
      {data.cards && (
        <div className={styles.itemsContainer}>
          {data.cards.map((post) => (
            <div
              key={post.title}
              className={styles.item}
            >
              <Img
                className={styles.image}
                src={post.icon.url}
                alt={post.title}
              />
              <h5 className={styles.title}>{post.title}</h5>
              <p className={styles.description}>{post.subtitle}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default FoundationSection;
